import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { emailsApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'
import type { EmailType } from '../../app/modules/types/email'
import type { OptionsType } from '../../app/modules/types/filters'

/**
 * Hook for fetching paginated emails list
 * Automatically refetches when URL params change
 */
export function useEmails() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.emails.list(orgId, params),
    queryFn: () => emailsApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching email filter options
 * Cached for 15 minutes as these change less frequently
 */
export function useEmailFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.emails.filterOptions(orgId),
    queryFn: () => emailsApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}
